var map = {
	"./LES SALADES.jpg": 360,
	"./ban1.jpg": 8747,
	"./ban2.jpg": 5948,
	"./ban3.jpg": 3993,
	"./ban4.jpg": 3306,
	"./infoPic.jpg": 5879,
	"./mascotte2.jpg": 8777,
	"./menu/CHAKLOUB.jpg": 7024,
	"./menu/HEALTHY FOOD.jpg": 2842,
	"./menu/LES SALADES.jpg": 7136,
	"./menu/PLATS DU JOUR.jpg": 7042,
	"./menu/SANDWICHS.jpg": 8233,
	"./menu/box.jpg": 2076,
	"./menu/menu kids.jpg": 7455,
	"./menu/pastas.jpg": 2631,
	"./produit1.jpg": 2084,
	"./produit2.jpg": 3368,
	"./produit3.jpg": 4037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;